import type { SYSAction } from "../../../../../../../_ovlclient/src"
import { Data } from "../../../../../../../_ovlclient/src/dataapi"
import { MergeDeep } from "../../../../../../../_ovlclient/src/global/actions"
import { T } from "../../../../../../../_ovlclient/src/global/globals"
import { SnackAdd } from "../../../../../../../_ovlclient/src/library/snackapi"
import {
  ProcessStart,
  ProcessEnd,
} from "../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"

const FetchOrders: SYSAction = async (_, { global }) => {
  ProcessStart("GENRefreshData")
  try {
    let state = global.getState()
    let res = await Data("data/getorders")
    if (!res.data) {
      return
    }
    if (!state.app.screens.DATOrder.orderDetail) {
      state.app.screens.DATOrder.orderDetail = { orders: res.data }
    } else {
      MergeDeep(state.app.screens.DATOrder.orderDetail, {
        orders: res.data,
      })
    }
  } finally {
    ProcessEnd("GENRefreshData")
  }
}

const FetchOrderDetail: SYSAction<
  { key?: string; silent?: boolean } | string | undefined
> = async (value, { global }) => {
  ProcessStart("GENRefreshData")
  try {
    let state = global.getState()
    let payload =
      typeof value === "object" ? value : { key: value, silent: false }
    let key =
      payload.key || state.app.screens.DATOrder.orderDetailFormState.selectedOrder
    let res = await Data("data/getorderdetail", parseInt(key))
    if (!res.data || res.data.attachments.files.length === 0) {
      if (!payload.silent) SnackAdd(T("SYSNoMatchingEntriesFound"), "Warning")
      if (!res.data) return
    }

    MergeDeep(state.app.screens.DATOrder.orderDetail.orders[key], res.data)
  } finally {
    ProcessEnd("GENRefreshData")
  }
}

const HookScreenRefresh: SYSAction = async (_, context) => {
  await FetchOrders(undefined, context)
}

const HookScreenNavigateIn: SYSAction = async (_, context) => {
  context.global.getState().app.screens.DATOrder.orderOverview.activeFilePopup =
    ""
  await FetchOrders(undefined, context)
}

const HookOrderDetailScreenNavigateIn: SYSAction = async (_, context) => {
  await FetchOrderDetail({ silent: true }, context)
}

let hooks = {
  HookScreenRefresh,
  HookScreenNavigateIn,
}

export let DATOrder = { hooks }

export let DATOrderdetail = {
  hooks: {
    HookScreenNavigateIn: HookOrderDetailScreenNavigateIn,
  },
  actions: { FetchOrderDetail },
}
